import { render, staticRenderFns } from "./RichTextBlock.vue?vue&type=template&id=9fdb7b52&scoped=true"
import script from "./RichTextBlock.vue?vue&type=script&lang=ts"
export * from "./RichTextBlock.vue?vue&type=script&lang=ts"
import style0 from "./RichTextBlock.vue?vue&type=style&index=0&id=9fdb7b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdb7b52",
  null
  
)

export default component.exports